const getHotelsFeaturedOnPage = (
	specialOfferHotelResults,
	mainBlockHotelResults,
	setHotelIdsFeaturedOnPage
) => {
	// We will add specialOfferHotelResults & mainBlockHotelResults to a list of hotel ids featured on the page - then when there is pageContent it will compare to make sure no duplicate hotels are added
	let specialOfferHotelIds = [],
		mainBlockHotelIds = [];

	if (specialOfferHotelIds.length !== specialOfferHotelResults.length) {
		specialOfferHotelIds =
			specialOfferHotelResults.length > 0
				? specialOfferHotelResults.map((offer) => offer._id)
				: [];
	}
	if (mainBlockHotelIds.length !== mainBlockHotelResults.length) {
		mainBlockHotelIds =
			mainBlockHotelResults.length > 0
				? mainBlockHotelResults.map((offer) => offer._id)
				: [];
	}

	if (specialOfferHotelIds.length > 0 || mainBlockHotelIds.length > 0) {
		const combinedResults = specialOfferHotelIds.concat(mainBlockHotelIds);
		setHotelIdsFeaturedOnPage(combinedResults);
	}
};

export { getHotelsFeaturedOnPage }